import { atomWithReset } from "jotai/utils";

import type { UserContext } from "@/lib/interfaces/user-context";

/**
 * The user loaded by the last full run of the root `beforeLoad`. Route preloads reuse it
 * instead of running the root again (see `__root.tsx`). Every logout resets it, so a
 * preload never hands the previous user to the child routes.
 */
export const resolvedUserAtom = atomWithReset<UserContext | undefined>(undefined);
